import { render, staticRenderFns } from "./kota.vue?vue&type=template&id=60792ef5"
import script from "./kota.vue?vue&type=script&lang=js"
export * from "./kota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports